import { IListModelQueryParamValues, IModelJsonValuesSchema } from '@sparelabs/http-client-utils'
import { z } from '@sparelabs/zod'

export enum AppointmentStatus {
  Booked = 'booked',
  InProgress = 'inProgress',
  Completed = 'completed',
  Cancelled = 'cancelled',
}

export const AppointmentSchema = IModelJsonValuesSchema.extend({
  appointmentTypeId: z.string().uuid().describe('The AppointmentType that was booked under'),
  caseId: z.string().uuid(),
  caseFormId: z.string().uuid(),
  adminId: z.string().uuid().describe('The admin that is selected to handle the appointment'),
  bookingId: z.string().describe('The Booking ID from Nylas'),
  eventId: z.string().describe('The Event ID from Nylas'),
  startTs: z.number().describe('The start time of the appointment in Unix seconds'),
  endTs: z.number().describe('The end time of the appointment in Unix seconds'),
  status: z.nativeEnum(AppointmentStatus).describe('The status of the appointment'),
})

export type IAppointmentResponse = z.infer<typeof AppointmentSchema>

export interface IListAppointmentQueryParams extends IListModelQueryParamValues {
  appointmentTypeId?: string
  caseId?: string
  riderId?: string
  adminId?: string
  fromStartTs?: number
  toStartTs?: number
  fromEndTs?: number
  toEndTs?: number
  status?: AppointmentStatus
  showCancelled?: boolean
}

export interface IAppointmentPostBody {
  appointmentTypeId: string
  caseId: string
  adminId: string
  startTs: number
  endTs: number
  metadata: Record<string, unknown>
}

export interface IAppointmentPatchBody {
  adminId?: string
  startTs?: number
  endTs?: number
}
